<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card :title="'QC TESTS'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-raw-material-qc-test-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="rm-qc-tests-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="incoterms">
              <template slot="thead">
                <vs-th sort-key="name">Test code</vs-th>
                <vs-th sort-key="name">Description</vs-th>
                <vs-th sort-key="name">Type</vs-th>
                <vs-th sort-key="name">Mandatory Status</vs-th>
                <vs-th>Action</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].test_code">
                    {{ data[indextr].test_code}}
                  </vs-td>
                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description}}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td :data="data[indextr].is_mandatory">
                      <span v-if="typeof data[indextr].is_mandatory === 'boolean'">
                            {{ data[indextr].is_mandatory ? 'Yes' : 'No' }}
                      </span>
                      <span v-else>
                        -
                      </span>

                  </vs-td>
                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button class="ml-3" @click="onClickUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <add-new-qc-test-pop-up ref="addNewQcTestPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import AddNewQcTestPopUp from "@/components/popups/settings/qc-tests/AddNewQcTestPopUp";

  export default {
    name: "CcpItemSettings",
    data() {
      return {
        incoterms: [],
      }
    },
    components: {
      AddNewQcTestPopUp,
    },
    methods: {
      async refreshData() {
        await this.fetchQcTests()
      },
      async fetchQcTests() {
        await this.$vs.loading({
          container: '#rm-qc-tests-table',
          scale: 0.45
        })
        const {data} =  (await SupplierRawMaterialRepository.getRawMaterialQCTests()).data
        this.incoterms =  data
        this.$vs.loading.close('#rm-qc-tests-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.addNewQcTestPopUp.openPopup()
      },
      async onClickUpdate(id) {
        await this.$refs.addNewQcTestPopUp.openPopup(id)
      },
    },
    async mounted() {
      await this.fetchQcTests()
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>

</style>
